import React from "react";

const separateUrls = (text) => {
  const urlRegex = /\bhttps?:\/\/\S+/gi;
  const urls = text.match(urlRegex);
  const separatedText = text.split(urlRegex);
  return {
    urls: urls || [],
    separatedText: separatedText || [],
  };
};

const LinkMessage = ({ message }) => {
  const { urls, separatedText } = separateUrls(message);

  return separatedText.map((text, index) => (
    <>
      {text}
      {urls[index] && (
        <a href={urls[index]} target="_blank" rel="noopener noreferrer">
          {urls[index]}
        </a>
      )}
    </>
  ));
};

export default LinkMessage;
